import React from 'react';
// import { VariableSizeList } from 'react-window';
import { Suspense, lazy } from 'react';
import './home.scss';
import  Globals from '../../api' ;
import { Helmet } from "react-helmet";
import ReactHtmlParser from 'react-html-parser';
const ElectionPoll = React.lazy(() => import("../../components/Electionpoll/ElectionPoll"));
const TopNews = React.lazy(() => import('../../components/TopNews/topnews'));
const TrandingNews = React.lazy(() => import('../../components/TrandingPagelist/trandingnews'));
const Horroscope = React.lazy(() => import('../../components/horroscope/horroscope'));
const SpecialVideo = React.lazy(() => import('../../components/SpecialVideo/specialvideo'));
const PageList1 = React.lazy(() => import('../../components/Pagelist1/PageList1'));
const PageList2 = React.lazy(() => import('../../components/Pagelist2/PageList2'));
const PageList3 = React.lazy(() => import('../../components/Pagelist3/PageList3'));
const PageList4 = React.lazy(() => import('../../components/Pagelist4/PageList4'));
const Pagelist5 = React.lazy(() => import('../../components/Pagelist5/PageList5'));
const Pagelist6 = React.lazy(() => import('../../components/Pagelist6/PageList6'));
const PageList7 = React.lazy(() => import('../../components/Pagelist7/PageList7'));
const PageList8 = React.lazy(() => import('../../components/Pagelist8/PageList8'));
const PageList9 = React.lazy(() => import('../../components/Pagelist9/PageList9'));
const PageList10 = React.lazy(() => import('../../components/Pagelist10/PageList10'));
const PageList11 = React.lazy(() => import('../../components/Pagelist11/PageList11'));
// const PageList12 = React.lazy(() => import('../../components/Pagelist12/PageList12'));
// const PageList13 = React.lazy(() => import('../../components/Pagelist13/PageList13'));
const HomeVideoswidget = React.lazy(() => import( '../../components/home_videos/home_videos'));
const BloggerWidget= React.lazy(() => import( '../../components/BloggerWidget/bloggerwidget'));
const MarketWidget = React.lazy(() => import( '../../components/MarketWidget/Marketwidget'));
const CoronaTracker = React.lazy(() => import( '../../components/Coronatracker/Coronatracker'));
const OpinionWidget = React.lazy(() => import( '../../components/opinionwidget/Opinionwidget'));
const CricketUpdate = React.lazy(() => import( '../../components/CricketUpdate/Cricketupdate'));
const TimelineWidget = React.lazy(() => import( '../../components/Timeline/Timeline'));
const Hp_top_300_250 = React.lazy(() => import( '../ad-units/Hp_top_300_250'));
const Hp_middle_300_250 = React.lazy(() => import( '../ad-units/Hp_middle_300_250'));
const Hp_middle_center_728_90 = React.lazy(() => import( '../ad-units/Hp_middle_center_728_90'));
const Hp_bottom_center_728_90 = React.lazy(() => import( '../ad-units/Hp_bottom_center_728_90'));
const Hp_top_center_728_90 = React.lazy(() =>
  import("../ad-units/Hp_top_center_728_90")
);
// import axios from "axios";

export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.setStateOfParent.bind(this);
        this.state = {
           data : [],
           videos : [],
           meta : [] ,
           title : [],
           meta_keywords : [],
           meta_description : [],
           PhotoGallery : [],
           CricketData :[],
           Coronadata : [],
           AdData :[],
           PollResult :[],
           electionData:[]


         };
      }
    
    setStateOfParent = (optionId,GroupId,PollId) => {
    // var bodyFormData = new FormData();
    console.log('pollID', PollId);
     console.log('groupID', GroupId);
     console.log('optionID', optionId);
     fetch(Globals.submit_poll_api+`&poll_id=${PollId}&group_id=${GroupId}&option_id=${optionId}&ip_address=feff`)
    //fetch("http://wsdev.webdunia.com/json/api-version4/submit-poll-desktop?&lang=hi&poll_id=2731&group_id=2419&option_id=7467&ip_address=feff")
        // axios({
        //     method : "post",
        //     url :Globals.poll_api,
        //     data: bodyFormData
        // }) 
        .then((res) => res.json())
        .then((data) => {
            
            this.setState({
              PollResult : data
            })
        })  
      }

      
      getVideos(){
        const url= Globals.language_based_api+'/videos';
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            
            this.setState({
              videos : data.Contents[2].out.list
            })
        })   
      }

      getAds(){
        const url= Globals.AdConfig;
                fetch(url)
                .then((res) => res.json())
                .then((data) => {
                  
                    this.setState({
                      AdData : data.AdContents[0].homepage
                    })
                    
                }) 
                
      }

      getCoronaTracker(){
        const url= 'https://ws-prod.webdunia.com/json/tracker-api/get-tracker?lang=hi';
                fetch(url)
                .then((res) => res.json())
                .then((data) => {
                  
                    this.setState({
                      Coronadata : data.results
                    })
                   // console.log("corona "+data);
                })   
      }
      getPhotoGallery(){
        const url= Globals.language_based_api+'/photo-gallery-new';
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            
            this.setState({
                PhotoGallery : data.Contents
            })
        })   
      }
      getCricketUpdate(){
        const url= Globals.Cricket_update_api;
        //const url ="https://m-marathidev.webdunia.com/ad-config/ticker-test.json";
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            this.setState({
              CricketData : data.CurrentMatches
              
            })
        })   
        //console.log("url ",url)
      }

      getElectionData(){
        const d = new Date();
        let day     = d.getDay();
        let hours   = d.getHours();
        let minutes = d.getMinutes();
        const url= "https://ws-prod.webdunia.com/json/page?lang=hi&url=%2F&t="+day+hours+minutes;
        //const url ="https://m-marathidev.webdunia.com/ad-config/ticker-test.json";
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            this.setState({
              electionData : data.Contents
              
            })
        })   
        //console.log("url ",url)
      }

    componentDidMount() {
        // console.log('api at header' + Globals.language_based_api);
            const url= Globals.language_based_api+'/home-page';
            fetch(url)
            .then((res) => res.json())
            .then((data) => {
              
                this.setState({
                  data : data.Contents,
                  meta : data.Meta ,
                  title : data.Title,
                  meta_keywords : data.Meta.keywords.Attributes.content,
                  meta_description : data.Meta.description.Attributes.content
                })
            }) 
        this.getVideos();  
        this.getCricketUpdate();
        this.getPhotoGallery();
        this.getCoronaTracker();
        this.getAds();
        //this.getElectionData();
          }
    
    render() {
        //console.log("pollResult :" , [this.state.PollResult])
    //     let ElectionPollObj = this.state.electionData.filter((x) => x.Type == "ElectionPoll");
    //    const DataItems = ElectionPollObj.map((item, i ) => {
    //    if(item){
    //      return(
    //             <div key={i}><ElectionPoll dataFromParent = { ReactHtmlParser(item.electionHtml)} /></div>
    //         )
    //     }
    //  } )
     let pollResult =  this.state.PollResult;
        const renderLoader = () => <div className='loading_screen'></div>;
        let PollListData = this.state.data.filter((x)=>x.Type == "Poll");
        if (Object.keys(this.state.PollResult).length> 0 ) {
                PollListData = [pollResult];
              //  console.log("poll intiate")
        }
      //   console.log("🚀 ~ file: home.js ~ line 179 ~ Home ~ render ~ PollListData", PollListData)
        return (

            <div className="home_wrapper">
               
                <div className="full_ads_block">
                 <Suspense fallback={renderLoader()}>
               <Hp_top_center_728_90 AdData= {this.state.AdData} />
             </Suspense>
             </div>
                <div className="m-t-15 container">
                {/* <div className="corona_sect_home">    */}
                {/* <Suspense fallback={renderLoader()}>
                   {DataItems}
                    </Suspense> */}
                    {/* </div> */}
                </div>
                <section className="container">
                    <div className="row">
                        <div className="col top_news">
                            {/* top news */}
                            <Suspense fallback={renderLoader()}>
                            <TopNews dataFromParent = {this.state.data}/>
                            </Suspense>
                        </div>
                        <div className="col tranding_news">
                            {/* trending news pagelist 1*/}
                            <Suspense fallback={renderLoader()}>
                            <TrandingNews dataFromParent = {this.state.data}/>
                            </Suspense>
                        </div>
                        <div className="col ads_336">
                            <div className="m-b-15 cleafix"></div>
                            <div className="ads_block right_ad">
                            <Suspense fallback={renderLoader()}>
                            <Hp_top_300_250 AdData= {this.state.AdData}/>
                            </Suspense>
                            </div>
                            <div className="m-b-15"></div>
                            {/* horoscope widget */}
                            <Suspense fallback={renderLoader()}>
                            <Horroscope Horoscope = {this.state.data}/>
                            </Suspense>
                        </div>
                    </div>
                </section>
                <div className="m-t-15">
                <div className="home_video_sect">
                    {/* videos widget */}
                    {(() => {
                     if (this.state.videos) {
                  return (
                <Suspense fallback={renderLoader()}>
                <SpecialVideo SpecialVideo = {this.state.videos}/>
                </Suspense>
            )
               }
        })()}
                   </div> 
                </div>
                {/* <div className="m-t-15">
                <Suspense fallback={renderLoader()}>
                   {DataItems}
                   </Suspense>
                </div> */}
                <section className="h_section3 m-t-20">
                    <div className="container">
                        <div className="row">
                            <div className="col h_l_col">
                                {/* pagelist 1 */}
                                <div className="h_page_list1">
                                <Suspense fallback={renderLoader()}>
                                <PageList1 dataFromParent = {this.state.data}/>
                                </Suspense>
                                </div>
                                <div className="ads_block m-t-10 m-b-10 ad_middle_center">
                                <Suspense fallback={renderLoader()}>
                                <Hp_middle_center_728_90 AdData= {this.state.AdData}/>
                                </Suspense>
                                </div>
                                {/* pagelist 2 */}
                                <Suspense fallback={renderLoader()}>
                                <PageList2 dataFromParent = {this.state.data}/>
                                </Suspense>
                            </div>
                            <div className="col h_r_col">
                                {/* cricket update widget */}
                                <Suspense fallback={renderLoader()}>
                                <CricketUpdate CricketData = {this.state.CricketData}/>
                                </Suspense>
                                <div className="m-b-15"></div>
                                <div className="m-b-15"></div>
                                {/* pagelist 3 */}
                                <Suspense fallback={renderLoader()}>
                                <PageList3 dataFromParent = {this.state.data}/>
                                </Suspense>
                                <div className="ads_block m-b-10 m-t-10">
                                <Suspense fallback={renderLoader()}>
                                <Hp_middle_300_250 AdData= {this.state.AdData}/>
                                </Suspense>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>

                <section className="grey_bg padding15">
                    <div className="container">
                    {/* pagelist 4 */}
                    <Suspense fallback={renderLoader()}>
                        <PageList4 dataFromParent = {this.state.data}/>
                        </Suspense>
                    </div>
                </section>

                <section className="padding15">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-4">
                            {/* pagelist 5 */}
                            <Suspense fallback={renderLoader()}>
                                <Pagelist5 dataFromParent = {this.state.data}/>
                                </Suspense>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-4">
                            {/* pagelist 6 */}
                            <Suspense fallback={renderLoader()}>
                                <Pagelist6 dataFromParent = {this.state.data}/>
                                </Suspense>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-4">
                            {/* pagelist 7 */}
                            <Suspense fallback={renderLoader()}>
                                <PageList7 dataFromParent = {this.state.data}/>
                                </Suspense>
                            </div>
                        </div>
                    </div>
                </section>
                {/* photo gallery widget */}
                <Suspense fallback={renderLoader()}>
                <HomeVideoswidget dataFromParent = {this.state.PhotoGallery}/>
                </Suspense>

                <div className='container m-t-20'>
                    <div className='row'>
                        <div className='col'>
                            {/* blog list  */}
                            <Suspense fallback={renderLoader()}>
                            <BloggerWidget dataFromParent = {this.state.data}/>
                            </Suspense>
                            <div className="ads_block m-t-20 m-b-10 ad_bottom_center"> 
                            <Suspense fallback={renderLoader()}>
                                <Hp_bottom_center_728_90 AdData= {this.state.AdData}/>
                                </Suspense></div>
                               {/* mgid composite ad  */}
                               
                            <div className="m-b-20 cleafix"></div>
                            <div className="row">
                            {/* pagelist 8 */}
                          
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                <Suspense fallback={renderLoader()}>
                                    <PageList8 dataFromParent = {this.state.data}/>
                                    </Suspense></div>
                                   
                            {/* pagelist 9  */}
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                <Suspense fallback={renderLoader()}>
                                    <PageList9 dataFromParent = {this.state.data}/>
                                    </Suspense></div>    
                            </div>
                            <div className="row">
                            
                            {/* pagelist 11  */}
                            
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                <Suspense fallback={renderLoader()}>
                                    <PageList11 dataFromParent = {this.state.data}/>
                                    </Suspense></div>
                                
                            </div>
                            {/* <div className="ads_block m-t-20 m-b-10"><img src={ads6} /></div> */}
                        </div>
                        <div className='col h_r_col'>
                            {/* market  */}
                            <Suspense fallback={renderLoader()}>
                            <MarketWidget dataFromParent = {this.state.data}/>
                            </Suspense>
                            <div className="m-b-15 cleafix"></div>
                            {/* opinion */}
                            <Suspense fallback={renderLoader()}>
                            <OpinionWidget dataFromParent = {PollListData} setStateOfParent = {this.setStateOfParent}/>
                            </Suspense>
                            <div className="m-b-15 cleafix"></div>
                            {/* pageList 10 */}
                           
                            <Suspense fallback={renderLoader()}>
                            <PageList10 dataFromParent = {this.state.data}/>
                            </Suspense>
                        </div>
                        
                    </div>
                    
                </div>
               
            </div>
        )
    }
}